import { Link } from 'react-router-dom';
import SafariNight from './assets/SafariNight.jpg';

function OvernightSafariPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage overnight-safari-hero">
        <div className="hero-content">
          <h1>Ebamba's Overnight Safari from Cape Town</h1>
          <p>Extend your adventure and immerse yourself in the African wilderness.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">A Deeper Dive into the Wild</h2>
          <div className="content-intro">
            <img src={SafariNight} alt="Overnight Safari" className="tour-main-image" />
            <p>For those seeking a more profound connection with nature, Ebamba Travel & Tours offers captivating overnight safari experiences from Cape Town. Spending a night at a luxury game lodge allows for more extensive game viewing opportunities, including crucial dawn and dusk drives when wildlife is most active. Escape the city and fall asleep to the sounds of the African bush.</p>
            <p>Our carefully selected lodges provide comfort and exceptional service amidst stunning wilderness settings. Enjoy delicious meals, relaxation by the pool, and expert-led game drives that bring you closer to Africa's incredible fauna and flora. This is more than just a safari; it's an immersive wilderness retreat.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Overnight Safari</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-moon"></i>
              <h4>Evening & Morning Game Drives</h4>
              <p>Experience critical game viewing times, increasing your chances of spotting nocturnal animals and predator activity.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-bed"></i>
              <h4>Luxury Lodge Accommodation</h4>
              <p>Relax in comfortable, well-appointed lodges with amenities designed for an unforgettable wilderness stay.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-utensils"></i>
              <h4>All-Inclusive Meals</h4>
              <p>Typically includes dinner, breakfast, and often lunch, served in a beautiful safari lodge setting.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-user-friends"></i>
              <h4>Personalized Attention</h4>
              <p>Benefit from smaller groups and more personalized service from lodge staff and rangers.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Overnighters</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The overnight safari was absolutely magical. Waking up to the sounds of the bush was incredible, and we saw so much more wildlife. Ebamba's recommendation was perfect!"</p>
              <span>– Chloe B. from Australia</span>
            </div>
            <div className="testimonial-card">
              <p>"Worth every penny! The lodge was fantastic, and the game drives were exhilarating. It felt like a true escape into the wild. Thank you, Ebamba!"</p>
              <span>– Greg F. from USA</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Plan Your Overnight Safari</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OvernightSafariPage;
